(function () {
  'use strict';

  // 当前归因窗口的存储 key：active 保存本窗口首次归因，lastActivityAt 保存最后活动时间。
  const STORAGE_KEYS = {
    active: 'wl_landing_attribution_active',
    lastActivityAt: 'wl_landing_attribution_last_activity_at'
  };

  const DEFAULT_SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  const MAX_VALUE_LENGTH = 120;
  const defaultParamValue = '';

  function getConfig() {
    return window.WBLandingAttributionConfig || {};
  }

  function getSessionTimeoutMs() {
    const config = getConfig();
    const configuredTimeout = Number(config.sessionTimeoutMs);

    return Number.isFinite(configuredTimeout) && configuredTimeout > 0
      ? configuredTimeout
      : DEFAULT_SESSION_TIMEOUT_MS;
  }

  const SESSION_TIMEOUT_MS = getSessionTimeoutMs();

  function getAvailableStorage() {
    const testKey = '__wl_storage_test__';

    try {
      // 优先使用 localStorage，可跨同域标签页去重，更接近 GA4 同浏览器用户口径。
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (localStorageError) {
      try {
        // localStorage 不可用时退回 sessionStorage，至少保证当前标签页内去重。
        window.sessionStorage.setItem(testKey, '1');
        window.sessionStorage.removeItem(testKey);
        return window.sessionStorage;
      } catch (sessionStorageError) {
        // 两种 storage 都不可用时，后续仍会尝试发送当前 URL 的归因事件。
        return null;
      }
    }
  }

  function normalizeValue(value) {
    if (!value) return defaultParamValue;

    // 清理参数值并限制长度，避免空白和异常长参数污染 GA4/BI 数据。
    return String(value).trim().slice(0, MAX_VALUE_LENGTH);
  }

  function getParam(params, name) {
    return normalizeValue(params.get(name));
  }

  function compactAttribution(attribution) {
    const result = {};

    // 只保留 URL 实际带值的归因字段，避免把空字符串写入 dataLayer。
    Object.keys(attribution).forEach(function (key) {
      if (attribution[key]) {
        result[key] = attribution[key];
      }
    });

    return result;
  }

  function getUrlAttribution() {
    const params = new URLSearchParams(window.location.search);

    // 默认 UTM 继续由 Google & YouTube 的 page_view 识别；本事件只在带标准 UTM 的落地页补充业务自定义参数。
    const hasStandardUtm = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term'
    ].some(function (name) {
      return Boolean(getParam(params, name));
    });

    if (!hasStandardUtm) {
      return null;
    }

    // 只采集业务自定义参数；不重复发送标准 UTM 或 page_view。
    return compactAttribution({
      platform: getParam(params, 'platform'),
      placement: getParam(params, 'placement'),
      creator: getParam(params, 'creator'),
      partner: getParam(params, 'partner'),
      traffic_type: getParam(params, 'traffic_type'),
      funnel: getParam(params, 'funnel')
    });
  }

  function readJson(storage, key) {
    try {
      const raw = storage.getItem(key);

      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeJson(storage, key, value) {
    storage.setItem(key, JSON.stringify(value));
  }

  function removeStoredSession(storage) {
    storage.removeItem(STORAGE_KEYS.active);
    storage.removeItem(STORAGE_KEYS.lastActivityAt);
  }

  function getLastActivityAt(storage) {
    return Number(storage.getItem(STORAGE_KEYS.lastActivityAt) || 0);
  }

  function isActiveSession(storage, now) {
    const lastActivityAt = getLastActivityAt(storage);

    return lastActivityAt && now - lastActivityAt <= SESSION_TIMEOUT_MS;
  }

  function updateActivity(storage, now) {
    storage.setItem(STORAGE_KEYS.lastActivityAt, String(now));
  }

  function clearExpiredSession(storage, now) {
    // 超过归因窗口无活动后，清掉旧状态，允许下一次带参进站重新发送。
    if (isActiveSession(storage, now)) return;

    removeStoredSession(storage);
  }

  function pushLandingAttribution(attribution) {
    // GTM 容器尚未加载时，事件先留在 dataLayer；首次交互加载容器后由同名 Custom Event trigger 转发 GA4。
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      attribution_version: 'v2',
      event: 'landing_attribution'
    }, attribution));
  }

  try {
    const now = Date.now();
    const storage = getAvailableStorage();
    const urlAttribution = getUrlAttribution();

    if (!storage) {
      // storage 不可用时无法去重，但仍发送当前 URL 归因，避免数据完全丢失。
      if (urlAttribution) {
        pushLandingAttribution(urlAttribution);
      }

      return;
    }

    clearExpiredSession(storage, now);

    if (readJson(storage, STORAGE_KEYS.active) && isActiveSession(storage, now)) {
      // 当前归因窗口已经发送过 landing 归因，只更新时间，不重复发送。
      updateActivity(storage, now);
      return;
    }

    if (!urlAttribution) {
      return;
    }

    // 新归因窗口：记录当前 URL 的首次归因，并推送给 GTM。
    writeJson(storage, STORAGE_KEYS.active, urlAttribution);
    updateActivity(storage, now);
    pushLandingAttribution(urlAttribution);
  } catch (error) {
    // Attribution tracking must never block storefront rendering.
  }
})();
